<div class="d-flex justify-content-end mb-2">
  <button class="btn btn-success btn-sm" (click)="addUser()">
    <fa-icon [icon]="faPlus" class="me-1"></fa-icon>
    Add User
  </button>
</div>

<app-table
  [compact]="true"
  [columns]="columns"
  [data]="userData"
  [totalCount]="resultsLength"
  [pageSize]="20"
  [loading]="isLoadingResults"
  [clickableRows]="true"
  [initialFilterValues]="{ accountDisabled: '{{bool}}false' }"
  (searchChange)="onSearch($event)"
  (rowClick)="editUser($event)">

  <ng-template tableCell="companyGroup" let-row>
    {{ row.companyGroup?.name }}
  </ng-template>

  <ng-template tableCell="lastLogin" let-row>
    <span *ngIf="row.lastLogin; else neverLoggedIn">{{ row.lastLogin | date:'dd-MM-yyyy HH:mm:ss' }}</span>
    <ng-template #neverLoggedIn><span class="text-danger fw-bold">Never</span></ng-template>
  </ng-template>

  <ng-template tableCell="lastActivity" let-row>
    <span *ngIf="row.lastActivity" class="d-flex align-items-center gap-2">
      <span class="rounded-circle d-inline-block"
            style="width: 8px; height: 8px;"
            [style.background-color]="isOnline(row.lastActivity) ? 'var(--bs-success)' : 'var(--bs-secondary)'">
      </span>
      {{ row.lastActivity | date:'dd-MM-yyyy HH:mm:ss' }}
    </span>
  </ng-template>

  <ng-template tableCell="accountDisabled" let-row>
    <span class="badge" [ngClass]="row.accountDisabled ? 'bg-danger' : 'bg-success'">
      {{ row.accountDisabled ? 'Disabled' : 'Enabled' }}
    </span>
  </ng-template>

</app-table>